<template>
    <div id="contact" class="contact">
        <div class="legend">Contact</div>
        <div class="container">
            <!-- <v-card class="card" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="100">
                <v-card-title>
                    <div class="icon">
                        <img class="icon-image" :src="require('@/assets/icons/phone.png')">
                    </div>
                    Phone
                </v-card-title>
                <v-card-text class="card-text">+30 6976921201</v-card-text>
            </v-card> -->
            <v-card class="card" href="mailto:karageorgosdim@yahoo.gr" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <v-card-title>
                    <div class="icon">
                        <img class="icon-image" :src="require('@/assets/icons/email.png')">
                    </div>
                    Email
                </v-card-title>
                <v-card-text class="card-text"><a class="mail">karageorgosdim@yahoo.gr</a></v-card-text>
            </v-card>
            <v-card class="card" href="https://www.linkedin.com/in/dimitris-karageorgos-296b59184" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="500">
                <v-card-title>
                    <div class="icon">
                        <img :src="require('@/assets/icons/linkedin.png')">
                    </div>
                    LinkedIn
                </v-card-title>
                <v-card-text class="card-text"><a class="linkedin">Check out my profile</a></v-card-text>
            </v-card>
        </div>
        <div class="qr-code" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="700">
            <div class="separator">OR</div>
            <v-img class="qr" :src="require('@/assets/images/contact-qr.png')" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Contact'
    }
</script>
<style scoped>

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.separator:not(:empty)::before {
  margin-right: 1.45rem;
}

.separator:not(:empty)::after {
  margin-left: 1.45rem;
}

.qr-code {
    align-self: center;
    padding-top: 5%;
}

.qr {
    max-width: 300px;
}

.contact {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding-top: 3%;
    padding-left: 5%;
}

.card {
    font-family: "Poppins";
    padding: 2em;
    min-width: 320px;
    margin-bottom: 1rem;
    background-color: #f5f8fc !important;
}

.icon {
    width: 3rem;
    height: 3rem;
    background: #01aebe;
    /* #34495e; */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
}

.icon-image {
    filter: invert(1);
}

.card-text {
    font-size: 1rem;
}

.legend {
    font-family: "Poppins-Bold";
    font-size: 2em;
    margin-left: 2%;
}

.container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-top: 5%;
}

.mail, .linkedin {
    text-decoration: none;
    color: #00000099;
}

@media screen and (max-width: 768px) {
    .contact {
        padding-left: 0;
    }
}
</style>
